module.exports = __webpack_public_path__ + "img/nickel_icon.9a102973.svg";